angular.module("riscattoAnticipato.components", []).component("riscattoAnticipato", {
    templateUrl: "ng/components/riscattoAnticipato/riscattoAnticipato.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "riscattoAnticipatoCtrl",
    controller: function RiscattoAnticipato(
        $arcService,
        $modalService,
        $RichiestePostVenditaService,
        $location,
        $rootScope,
        $timeout,
        Contratti,
        RiUserG,
        RichiestePostVendita,
        $configService
    ) {
        var self = this;

        self.$onInit = function () {
            self.validationContatti = true;
            self.mapInfo = "";
            self.showMe = true;
            self.supportModel = {
                fatturazioneOk: false,
                datiTerzoOk: false,
                hideButtons: false,
                isImmobiliare: false
            };
            if (self.richiestePostVendita.viewIndex == 0) {
                self.richiestePostVendita.viewIndex = 1550;
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA4' && self.richiestePostVendita.applicationName == 'RISCATTO' && self.richiestePostVendita.metadata.riscattoAnticipato.terzo) {
                self.richiestePostVendita.metadata.riscattoAnticipato.terzo.datiIncompleti = !RiUserG.build(self.richiestePostVendita.metadata.riscattoAnticipato.terzo).isOk(false, false, false, true)
            }

            if (typeof self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTotale == "undefined") {
                self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTotale = true;
            }

            if (!self.richiestePostVendita.typeWf || !self.richiestePostVendita.applicationName) {
                self.richiestePostVendita.typeWf = "WF_POSTVENDITA";
                self.richiestePostVendita.applicationName = "RISCATTO";
            }

            if (self.richiestePostVendita.metadata.ctrRichiestaList && self.richiestePostVendita.metadata.ctrRichiestaList[0]) {
                self.richiestePostVendita.metadata.riscattoAnticipato.prodottoTargato =
                    self.richiestePostVendita.metadata.ctrRichiestaList[0].cluster === "TARGATO" ? true : false;

                self.richiestePostVendita.metadata.riscattoAnticipato.prodottoImm =
                    self.richiestePostVendita.metadata.ctrRichiestaList[0].cluster === "IMMOBILIARE" ? true : false;

                self.richiestePostVendita.metadata.riscattoAnticipato.prodottoNav =
                    self.richiestePostVendita.metadata.ctrRichiestaList[0].cluster === "AERONAUTICO" ? true : false;

                self.prodottoNav = self.richiestePostVendita.metadata.ctrRichiestaList[0].codProdotto == 'NAV' ? true : false;

            }

            var contratti = [];
            if (self.richiestePostVendita.metadata.riscattoAnticipato.contratti.length == 0) {
                self.richiestePostVendita.metadata.ctrRichiestaList.forEach(function (contratto) {
                    contratti.push(Contratti.build({
                        numero: contratto.numeroContratto,
                        modulo: contratto.numeroModulo,
                        selected: true,
                        codProdotto: contratto.codProdotto,
                        cluster: contratto.cluster
                    }));
                });

                self.richiestePostVendita.metadata.riscattoAnticipato.contratti = contratti;
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                self.popoleteCheckList();
                callRestInfoCcBank();
                self.getStepInfoDetails();
            }
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCONFIMM') {
                self.popoleteCheckListConferma();
                self.getStepInfoDetails();
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA3') {
                callgetSignSelectionInfo();
                self.richiestePostVendita.metadata.riscattoAnticipato.firmaDigitaleEsterna = true;
            }
            if (self.richiestePostVendita.metadata.riscattoAnticipato && self.richiestePostVendita.metadata.riscattoAnticipato.names) {
                self.upgradeInfoLegRappresentante = self.richiestePostVendita.metadata.riscattoAnticipato.names[$configService.getUser().identifier];
            }

            retrieveStepInfo();
        }

        self.allegatiChange = function (value) {
            if (self.richiestePostVendita.metadata.attachedDocs.length > 0) {
                self.richiestePostVendita.metadata.attachedDocs.push(value);
            } else {
                self.richiestePostVendita.metadata.attachedDocs[0] = value;
            }
        }

        self.popolateCheckListDownload = function () {
            self.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentDownload = response.listDocuments;
                    self.visibleDownloadChecklist = response.visible;
                    self.messageDownload = response.message;
                    self.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        self.popolateCheckListUpload = function () {
            self.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    // self.listOfDocumentUpload = response.listDocuments;
                    // self.visibleUploadChecklist = response.visible;
                    // self.messageUpload = response.message;
                    // self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        self.popoleteCheckList = function () {
            self.restUploadRunning = true;
            $arcService.checklistPv(self.richiestePostVendita)
                .then(function (response) {
                    console.log("Checklist postVendita:", response)
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.messageUpload = response.messageUpload;
                    self.messageDownload = response.messageDownload;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }
        self.popoleteCheckListConferma = function () {
            self.restUploadRunning = true;
            $arcService.checklistPvConferma(self.richiestePostVendita)
                .then(function (response) {
                    console.log("Checklist postVendita:", response)
                    self.listOfDocumentUploadConferma = response.listDocuments;
                    self.visibleUploadChecklistConferma = response.visible;
                    self.messageUploadConferma = response.messageUpload;
                    self.messageDownloadConferma = response.messageDownload;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        self.next = function (fromModal) {
            self.enabledLoader = true;
            self.validityComponent = false;
            cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName)

            switch (self.getWizardMap(self.richiestePostVendita.viewIndex)) {
                case "RCKCLI":
                    if (fromModal) {
                        $RichiestePostVenditaService
                            .submitriscattoAnticipato(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                                self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                            .then(function (response) {
                                self.enabledLoader = false;
                                if (response.success) {
                                    $modalService.closeModal('preSubmitRiscAnt-modal');
                                    $rootScope.$broadcast("addAlert", {
                                        text: "REQUEST_PV_SUBMITTED"
                                    })
                                    $location.path('/');
                                } else {
                                    $rootScope.$broadcast("addAlert", {
                                        text: "LBL_QBEI_UNEXPECTED"
                                    })
                                }

                            }).catch(function (error) {
                                console.log(error);
                                self.enabledLoader = false;
                            });

                    } else {
                        $RichiestePostVenditaService
                            .preSubmitRiscAnt(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                                self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                            .then(function (response) {
                                if (response.success) {
                                    self.messagePreSubmit = response.messages;
                                    if (response.showPopup) {
                                        self.enabledLoader = false;
                                        $modalService.openModal('preSubmitRiscAnt-modal');
                                    } else {
                                        $RichiestePostVenditaService
                                            .submitriscattoAnticipato(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                                                self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                                            .then(function (response) {
                                                self.enabledLoader = false;
                                                if (response.success) {
                                                    $rootScope.$broadcast("addAlert", {
                                                        text: "REQUEST_PV_SUBMITTED"
                                                    })
                                                    $location.path('/');
                                                }

                                            }).catch(function (error) {
                                                console.log(error);
                                                self.enabledLoader = false;
                                            });
                                    }

                                } else {
                                    self.enabledLoader = false;
                                    $rootScope.$broadcast("addAlert", {
                                        text: "LBL_QBEI_UNEXPECTED"
                                    })

                                }

                            }).catch(function (error) {
                                console.log(error);
                                self.enabledLoader = false;
                            });

                    }
                    break;

                case "RA1":
                case "RA2":
                    self.enabledLoader = false;
                    $timeout(function () {
                        $modalService.openModal('acceptModal');
                    }, 400)
                    break;

                case "RCKCLITER":
                    $modalService.closeModal("acceptModal");
                    self.enabledLoader = true;
                    if (fromModal) {
                        $RichiestePostVenditaService
                            .submitriscattoAnticipatoTerzo(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                                self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                            .then(function (response) {
                                self.enabledLoader = false;
                                if (response.success) {
                                    $modalService.closeModal('preSubmitRiscAnt-modal');
                                    $rootScope.$broadcast("addAlert", {
                                        text: "REQUEST_PV_SUBMITTED"
                                    })
                                    $location.path('/');
                                } else {
                                    $rootScope.$broadcast("addAlert", {
                                        text: "LBL_QBEI_UNEXPECTED"
                                    })
                                }

                            }).catch(function (error) {
                                console.log(error);
                                self.enabledLoader = false;
                            });

                    } else {
                        $RichiestePostVenditaService
                            .preSubmitRiscAnt(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                                self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                            .then(function (response) {
                                if (response.success) {
                                    self.messagePreSubmit = response.messages;
                                    if (response.showPopup) {
                                        self.enabledLoader = false;
                                        $modalService.openModal('preSubmitRiscAnt-modal');
                                    } else {
                                        $RichiestePostVenditaService
                                            .submitriscattoAnticipatoTerzo(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                                                self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                                            .then(function (response) {
                                                self.enabledLoader = false;
                                                if (response.success) {
                                                    $rootScope.$broadcast("addAlert", {
                                                        text: "REQUEST_PV_SUBMITTED"
                                                    })
                                                    $location.path('/');
                                                }

                                            }).catch(function (error) {
                                                console.log(error);
                                                self.enabledLoader = false;
                                            });
                                    }

                                } else {
                                    self.enabledLoader = false;
                                    $rootScope.$broadcast("addAlert", {
                                        text: "LBL_QBEI_UNEXPECTED"
                                    })

                                }

                            }).catch(function (error) {
                                console.log(error);
                                self.enabledLoader = false;
                            });

                    }
                    break;

                case "RA4":
                    self.enabledLoader = true;
                    $RichiestePostVenditaService
                        .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                        .then(function (response) {
                            self.enabledLoader = false;
                            self.richiestePostVendita = response;
                            retrieveStepInfo();
                            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                                self.popoleteCheckList();
                                callRestInfoCcBank();
                                self.getStepInfoDetails();
                            }
                            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA3') {
                                callgetSignSelectionInfo();
                                self.richiestePostVendita.metadata.riscattoAnticipato.firmaDigitaleEsterna = true;
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.enabledLoader = false;
                        });

                    break;

                case "RCONFIMM":
                    $RichiestePostVenditaService
                        .submitriscattoAnticipatoImmConf(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                            self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                        .then(function (response) {
                            self.enabledLoader = false;
                            if (response.success) {
                                $rootScope.$broadcast("addAlert", {
                                    text: "REQUEST_PV_SUBMITTED"
                                })
                                $location.path('/');
                            } else {
                                $rootScope.$broadcast("addAlert", {
                                    text: "LBL_QBEI_UNEXPECTED"
                                })
                            }

                        }).catch(function (error) {
                            console.log(error);
                            self.enabledLoader = false;
                        });

                    break;

                default:
                    self.enabledLoader = true;
                    $RichiestePostVenditaService
                        .generateAllegatiPv(self.richiestePostVendita)
                        .then(function (response) {
                            if (response.success) {
                                $RichiestePostVenditaService
                                    .nextStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                    .then(function (response) {
                                        self.enabledLoader = false;
                                        self.richiestePostVendita = response;
                                        retrieveStepInfo();
                                        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                                            self.popoleteCheckList();
                                            callRestInfoCcBank();
                                            self.getStepInfoDetails();
                                        }
                                        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA3') {
                                            callgetSignSelectionInfo();
                                            self.richiestePostVendita.metadata.riscattoAnticipato.firmaDigitaleEsterna = true;
                                        }
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                        self.enabledLoader = false;
                                    });
                            } else {
                                self.enabledLoader = false;
                            }

                        }).catch(function (error) {
                            console.log(error);
                            self.enabledLoader = false;
                        });
                    break;
            }
        }

        self.acceptRiscatto = function () {
            self.enableModalLoader = true;
            self.enabledLoader = true;
            $modalService.closeModal("acceptModal");
            $RichiestePostVenditaService.preAcceptRiscAnt(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function (response) {
                    if (response.showPopup) {
                        self.enabledLoader = false;
                        self.messagePreAccept = response.messages
                        $modalService.openModal('preAcceptRiscAnt-modal');
                    } else {
                        $RichiestePostVenditaService
                            .acceptRiscattoAnticipato(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                            .then(function (response) {
                                self.enabledLoader = false;
                                if (response.goHome) {
                                    $location.path('/');
                                } else {
                                    self.richiestePostVendita.viewIndex = response.viewIndex;
                                    self.richiestePostVendita.metadata.riscattoAnticipato.terzo = response.metadata.riscattoAnticipato.terzo;
                                    retrieveStepInfo();
                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLI' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCKCLITER') {
                                        self.popoleteCheckList();
                                        callRestInfoCcBank();
                                        self.getStepInfoDetails();
                                    }
                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA3') {
                                        callgetSignSelectionInfo();
                                        self.richiestePostVendita.metadata.riscattoAnticipato.firmaDigitaleEsterna = true;
                                    }
                                }
                            }).catch(function (error) {
                                console.log(error);
                                self.enabledLoader = false;
                            })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    self.enableModalLoader = false;
                    self.enabledLoader = false;
                })

            self.enableModalLoader = false;
        }

        self.submitriscattoAnticipato = function (fromModal) {
            $modalService.closeModal("acceptModal");
            self.enabledLoader = true;
            if (fromModal) {
                $RichiestePostVenditaService
                    .submitriscattoAnticipato(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                        self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        self.enabledLoader = false;
                        if (response.success) {
                            $modalService.closeModal('preStartRiscAnt-modal');
                            $location.path('/');
                        }

                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });

            } else {
                $RichiestePostVenditaService
                    .preStartRiscAnt(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                        self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        self.messagePreStart = response.messages;
                        if (response.showPopup) {
                            self.enabledLoader = false;
                            $modalService.openModal('preStartRiscAnt-modal');
                        } else {
                            $RichiestePostVenditaService
                                .submitriscattoAnticipato(self.richiestePostVendita.metadata.riscattoAnticipato, self.richiestePostVendita.id,
                                    self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                                .then(function (response) {
                                    self.enabledLoader = false;
                                    if (response.success) {
                                        $location.path('/');
                                    }

                                }).catch(function (error) {
                                    console.log(error);
                                    self.enabledLoader = false;
                                });

                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    })

            }


        }

        self.sospendi = function () {
            self.enabledLoaderSuspend = true;
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    self.enabledLoaderSuspend = false;
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                }).catch(function (error) {
                    console.log(error);
                    self.enabledLoaderSuspend = false;
                })
        }

        self.back = function () {
            if (self.richiestePostVendita.readOnly) {
                $location.path('/');
            } else {
                self.enabledLoaderBack = true;
                $RichiestePostVenditaService
                    .backStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.enabledLoaderBack = false;
                        self.richiestePostVendita = response;
                        retrieveStepInfo();
                        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RA3') {
                            callgetSignSelectionInfo();
                            self.richiestePostVendita.metadata.riscattoAnticipato.firmaDigitaleEsterna = true;
                        }
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoaderBack = false;
                    })
            }
        }

        self.closeModal = function () {
            $modalService.closeModal("suspendInstance");
        }

        self.closeAcceptanceModal = function (idModal) {
            $modalService.closeModal(idModal);
            self.enabledLoader = false;
            if (idModal == 'preAcceptRiscAnt-modal') {
                $location.path('/')
            }
            self.validityComponent = true;
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                    self.clearLabelInfo = false;
                });
        }

        self.fattElettronica = function (fattElettronica, value) {
            if (fattElettronica) {
                self.richiestePostVendita.metadata.riscattoAnticipato.terzo.sedeFatturazione.fatturazione = fattElettronica;
                self.supportModel.fatturazioneOk = value;
                checkValidity();
            }
        }

        self.handleCervedInfos = function (value, riUserG) {
            self.richiestePostVendita.metadata.riscattoAnticipato.terzo = riUserG;
            checkValidity();
        }

        var checkValidity = function () {
            var test = self.supportModel.fatturazioneOk && !self.richiestePostVendita.metadata.riscattoAnticipato.terzo.datiIncompleti;
            self.validatePage(test);
            self.nextValidity();

        }

        self.validatePage = function (validity) {
            self.validityComponent = validity;
        }

        self.validateUpload = function (validity) {
            self.validityComponent = validity;
            self.nextValidity();
        }

        self.nextValidity = function () {
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'RCONFIMM') {
                return self.validateComponentConfermaAccettazione;
            } else {
                return self.validityComponent &&
                    self.validationContatti;
            }
        }

        self.validateFirmatario = function (validity, buttonPress) {
            self.validityFirmatario = validity;
            self.validateFirmatarioPage();
            if (validity && buttonPress) {
                self.next();
            }
        }

        self.validateInformazioniImmobile = function (validity) {
            self.validityImmobile = validity;
            self.validateFirmatarioPage();
        }

        self.validateFirmatarioPage = function () {
            if (self.supportModel.isImmobiliare) {
                self.validityComponent = self.validityImmobile && self.validityFirmatario;
                self.nextValidity();
            } else {
                self.validityComponent = self.validityFirmatario;
                self.nextValidity();
            }
        }

        self.firmaChangedFn = function () {
            self.firmaChanged = !self.firmaChanged;
        }


        var callgetSignSelectionInfo = function () {
            $arcService.getSignSelectionInfo(self.richiestePostVendita.id)
                .then(function (response) {
                    self.showSignMode = response.signModeVisible;
                    self.digitalSignOnly = response.digitalSignOnly;
                })
                .catch(function (error) {

                })
        };

        self.getStepInfoDetails = function () {
            $arcService.getStepInfoDetails(self.richiestePostVendita)
                .then(function (response) {
                    self.stepInfDetailsResponse = response;
                })
                .catch(function (error) {
                    console.error(error);
                })

        }


        self.validityContatti = function (value) {

            self.validationContatti = value;
        }

        var callRestInfoCcBank = function () {

            $arcService.ibanRiscAnt(self.richiestePostVendita.id)
                .then(function (element) {
                    console.log(element);
                    self.modelCcBancarie = element;
                })
        }

        self.validateComponentConfermaAccettazioneFn = function (value) {
            self.validateComponentConfermaAccettazione = value
            self.nextValidity();
        }

    }
})